import React, { useEffect, useRef, useState } from 'react';
import Nav from "../../components/Nav";
import Body from "../../components/Body";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { useClientBanks } from "../../state/clientbankState";
import { Toast } from 'primereact/toast';
import { OverlayPanel } from 'primereact/overlaypanel';
import useHasRole from "../../hooks/validRolesHook";
import NotFound from "../Global/404NotFound";
import Loading from "../Global/loading";
import { getTenantPath } from '../Global/TenantPath';
export default function Clientbanks() {
    const navigate = useNavigate();
    const { clientBanksStatus, clientBanksData, clientBanksError } = useClientBanks();

    const toast = useRef<Toast>(null);
    const op = useRef<OverlayPanel>(null);
    const _opMsg = useRef("");
    const [_opMsgState, set_opMsgState] = useState(_opMsg.current);

    const onRowClick = (e: any) => {
        //navigate(`/clientbanks/${e.data.ClientBankId}`);
        navigate(getTenantPath(`clientbanks/${e.data.ClientBankId}`));
    }

    useEffect(() => {
        if (clientBanksError) {
            // alert('Error saving user');
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'There was a server error while saving the user. Please try again later.', life: 10000 });
        }
    }, [clientBanksError]);
//const { hasRoles: isSecurityAdmin } = useHasRole(["Security Administrator"]);
const { hasRoles: isMasterAdmin } = useHasRole(["Master Administrator"]);
    const header = (
        <div className="flex justify-content-between">
            <h1>Clientbanks</h1>
            {isMasterAdmin && (
                //<Button label="Add Clientbank" icon="pi pi-plus" onClick={() => navigate('/clientbanks/new')} />
                <Button label="Add Clientbank" icon="pi pi-plus" onClick={() => navigate(getTenantPath('clientbanks/new'))} />
                
            )}
        </div>
    );

    // Security to check if the user has any of the allowed roles.
    // NOTE: Keep below any react.js "use" items (i.e., useHook, useEffect, useState, useMemo, etc.)
    let {hasRoles, isLoading} = useHasRole(['Account Administrator', 'System Administrator', 'Account Manager', 'Master Administrator']);
    

    if (isLoading) {
        return <Loading />
    }
    else if (!hasRoles) {
        return NotFound();
    }

    return (
        <div>
            <Nav />

            <Body>

                <OverlayPanel ref={op}>
                    <div>{_opMsg.current}</div>
                </OverlayPanel>
                <Toast ref={toast} position="bottom-center" />

                <DataTable value={clientBanksData} paginator rows={20} dataKey="id" loading={clientBanksStatus === 'pending'}
                    emptyMessage="No Client Banks found" alwaysShowPaginator={false} selectionMode="single"
                    header={header}
                    onRowSelect={onRowClick}
                    paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    scrollHeight='55.6vh'
                >
                    <Column field="ClientBankName" header="Client Bank Name" sortable filter />
                    <Column field="ClientBankSource" header="Client Bank Source" sortable filter />
                    <Column field="Street" header="Street" sortable filter />
                    <Column field="City" header="City" sortable filter />
                    <Column field="State" header="State" sortable filter />
                    <Column field="PostalCode" header="Postal Code" sortable filter />
                    <Column field="Country" header="Country" sortable filter />
                    <Column field="ShippingStreet" header="Shipping Street" sortable filter />
                    <Column field="ShippingCity" header="Shipping City" sortable filter />
                    <Column field="ShippingState" header="Shipping State" sortable filter />
                    <Column field="ShippingPostalCode" header="Shipping Postal Code" sortable filter />
                    <Column field="ShippingCountry" header="Shipping Country" sortable filter />
                    <Column field="RecordStatus"  header="Record Status" sortable filter />
                    <Column field="AccountName"  header="Account Name" sortable filter />
                </DataTable>
            </Body>
        </div>
    )
}
